export const notificationsEn = {
  title: "Notifications",
  open: "Notifications (%{smart_count} unread) |||| Notifications (%{smart_count} unread)",
  empty: "No notifications",
  mark_all: "Mark all as read",
  // GAVION X4: daily digest opt-out (Profile)
  digest: {
    title: "Daily summary",
    description:
      "Every business-day morning at 7:30: today's callbacks and demos, your hot leads, the stop requests to decide and yesterday's results. You get it in the CRM and, when your Outlook mailbox is connected, by email.",
    toggle: "Receive the daily summary",
    on: "Daily summary turned on",
    off: "Daily summary turned off",
    error: "Your choice could not be saved. Please try again.",
  },
  // GAVION rep-missed-call: the rep's own « Missed call » email switch (Profile)
  missed_call: {
    title: "« Missed call » email",
    toggle: "Automatic email after an unanswered call",
    help: "Off by default. Once on, after « No answer » or « Voicemail left », the lead gets the « Missed call — Gala » email from your Outlook (once per lead).",
    edit: "Edit the email",
    edit_en: "English version",
    on: "« Missed call » email turned on: it will go out after your unanswered calls",
    off: "« Missed call » email turned off",
    error: "Your choice could not be saved. Please try again.",
  },
};
